import { ShareNetwork } from '@phosphor-icons/react';

// Non-admin view: availability counts only, no owner/device detail.
export default function UserVlanSummary({ vlans }) {
  return (
    <div className="space-y-5" data-testid="user-vlan-summary">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-zinc-900">VLAN・IP空き状況</h1>
        <p className="text-sm text-zinc-500 mt-1">各ネットワークの空きIPアドレス数です。</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="user-vlan-summary-cards">
        {vlans.map((v) => {
          const total = v.total || 0;
          const available = v.available != null ? v.available : total - (v.assigned || 0);
          const pct = total ? Math.round(((v.assigned || 0) / total) * 100) : 0;
          const warn = pct >= 90;
          return (
            <div
              key={v.id}
              data-testid={`user-vlan-card-${v.key}`}
              className="bg-white rounded-xl border border-slate-200 shadow-sm p-5 flex flex-col"
            >
              <div className="flex items-center gap-2 text-zinc-700">
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-blue-100 text-teal-700">
                  <ShareNetwork size={16} weight="duotone" />
                </span>
                <span className="font-semibold">{v.name}</span>
              </div>
              <p className="font-mono text-xs text-zinc-400 mt-2">{v.subnet || '—'}</p>
              <div className="mt-4 flex items-baseline gap-1.5">
                <span className={`text-4xl font-bold tabular-nums ${warn ? 'text-rose-600' : 'text-teal-700'}`}>{available}</span>
                <span className="text-sm text-zinc-500">空き / 全{total}</span>
              </div>
              <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden mt-3">
                <div
                  className={`h-full rounded-full ${warn ? 'bg-rose-500' : 'bg-teal-700'}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
              <p className="text-[11px] text-zinc-400 mt-1.5">{v.assigned || 0} 件 使用中（{pct}%）</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
